<template>
    <div class="alternative_checkout">

        <!-- Top Bar -->
        <div class="bar container-fluid" :style="{ 'background': mainColor }">
            <div class="row justify-content-center">
                <div class="col-sm col-md-6 text-center" :style="{'min-height':'10vh'}">
                    <router-link to="/" class="top-bar-logo">
                        <img :style="{'min-height':'5vh','margin':'2.5vh 0'}" v-if="portal.id != 0"
                             :src="portal.foto_principal.replace('http:', 'https:')"/>
                    </router-link>
                </div>
            </div>
        </div>

        <!-- Content -->
        <div class="container-fluid">
            <div class="row content justify-content-center">
                <div class="col-sm col-md-6 text-center">
                    <img :src="curso.foto_principal" class="img-fluid card-img-top" alt="">
                    <h2 class="card-title" :style="{'color': mainColor}" v-html="curso.producto"></h2>
                    <p class="card-text" :style="{'color': 'black' }"
                       v-html="curso.productos_categorias[0].categorias_productos[0].descripcion"></p>
                    <button
                        type="button"
                        class="btn btn-light btn-lg"
                        :style="{
                            'font-weight': 'bold',
                            'color': 'white',
                            'background-color': mainColor,
                            'border-radius': '4em/4em',
                            'margin': '20px'
                        }"
                        :disabled=" this.isLoadingPagoUrl == true "
                        @click="pagar">
                        Suscribir
                        <spinner v-if="isLoadingPagoUrl" class-name="color-white"/>
                    </button>

                </div>
            </div>
        </div>


        <!-- Modal Pago url -->
        <b-modal
            v-model="isPagoUrlLandingModalVisible"
            :busy="true"
            centered
            hide-footer
            title="Notificación">
            <div class="text-center alert-text-box">
                <p v-if="this.isPagoLandingMessage=='' && dif_operador==false">
                    Redireccionando
                    <spinner class-name="color-red"/>
                </p>
                <p v-if="this.isPagoLandingMessage!=''">{{ this.isPagoLandingMessage }}</p>
            </div>
        </b-modal>

        <b-modal v-model="dif_operador"
                 :busy="true"
                 centered
                 hide-footer
                 title="Error de Operador" class="text-center">
            <div class="text-center alert-text-box">
                <p>Lo sentimos. Su operador no se permite para este contenido.</p>
            </div>
            <router-link :to="{name: 'home'}">
                <button
                    type="button"
                    class="btn btn-light btn-lg"
                    :style="{
                            'font-weight': 'bold',
                            'color': 'white',
                            'background-color': mainColor,
                            'border-radius': '4em/4em',
                            'margin': '20px'
                        }">
                    Ver otros contenidos
                </button>
            </router-link>
        </b-modal>

        <!-- Modal Id Session Modal Entel -->
        <b-modal v-model="isIdSessionEntelModalVisible"
                 :busy="true"
                 centered
                 hide-footer
                 title="Confirmación">

            <div class="form-group text-center">
                <h5>{{ curso.producto }}</h5>
                <h3 class="font-weight-bold">{{ msisdnEntel }}</h3>
                <spinner v-if="msisdnEntel=='Espere por favor'" class-name="red-white"/>
                <div class="row">
                    <div class="col">
                        <button type="button" class="btn btn-light btn-lg"
                                :style="{
                            'font-weight': 'bold',
                            'color': 'white',
                            'background-color': mainColor,
                            'border-radius': '4em/4em'}"
                                :disabled=" this.isLoadingPagoUrl == true || this.telefono==''"
                                v-on:click="openConfirmUser">
                            Suscribir
                        </button>
                        <br>
                        <br>
                        <div v-if="errorMessage != ''">
                            <div class="alert-text-box checkout-error-message">{{ errorMessage }}</div>
                            <div class="text-center alert-text-box"
                                 :class="{'color-red': !colorMensajeMovil ,'color-green': colorMensajeMovil}"
                                 v-if="movilMessage != ''"
                            >{{ movilMessage }}
                            </div>
                        </div>
                    </div>
                </div>
                <label class="checkbox-inline mr-4">
                    <label class="checkbox-inline mr-4">
                        <div class="texto" v-if="selectedPortalPasarela"
                             v-html="(typeof selectedPortalPasarela.pasarela.descripcion_operador !=='undefined' )? selectedPortalPasarela.pasarela.descripcion_operador : '' "
                        ></div>
                    </label>
                </label>
            </div>
        </b-modal>

        <b-modal v-model="confirm_of_user"
                 :busy="true"
                 centered
                 hide-footer
                 title="Confirmacion" class="text-center">
            <div class="form-group text-center">
                <h5>{{ curso.producto }}</h5>
                <br>
                <button
                    @click="pagar"
                    type="button"
                    class="btn btn-light btn-lg"
                    :style="{
                            'font-weight': 'bold',
                            'color': 'white',
                            'background-color': '#ff0000a3',
                            'border-radius': '4em/4em',
                            'margin': '20px'
                        }">
                    Confirmar Suscripción
                    <spinner v-if="isLoadingPagoUrl" class-name="color-white"/>
                </button>
                <br>
                <label class="checkbox-inline mr-4">
                    <div class="texto" v-if="selectedPortalPasarela"
                         v-html="(typeof selectedPortalPasarela.pasarela.descripcion_operador !=='undefined' )? selectedPortalPasarela.pasarela.descripcion_operador : '' "
                    ></div>
                </label>
            </div>
        </b-modal>

        <!-- Modal Movil -->
        <b-modal v-model="isMovilModalVisible" :busy="true" centered title="Suscribir" hide-footer>
            <div class="form">
                <div class="form-group">
                    <input
                        v-model="telefono_suscribir"
                        class="form-control text-center"
                        type="text"
                        maxlength="12"
                        placeholder="Ingrese numero de telefono"
                        ref="telefono_suscribir"
                    />
                </div>
                <div class="form-group d-flex justify-content-center">
                    <button class="btn btn-primary btn-noradius" @click="PagoMovil">
                        Confirmar Suscripción
                        <spinner v-if="isLoadingPagoMovilUrl" class-name="color-white"/>
                    </button>
                </div>
                <div
                    class="text-center alert-text-box"
                    :class="{
                        'color-red': !colorMensajeMovil ,
                        'color-green': colorMensajeMovil
                    }"
                    v-if="movilMessage != ''"
                >
                    {{ movilMessage }}
                </div>
            </div>
        </b-modal>

        <!-- Modal PIN -->
        <b-modal
            v-model="isPinModalVisible"
            :busy="true"
            centered
            title="SOLICITUD DE PIN AUTENTICACIÓN"
            hide-footer
        >
            <div class="form">
                <div class="form-group">
                    <label>Ingrese el codigo PIN que llegara a su telefono</label>
                    <input
                        v-model="pin"
                        class="form-control text-center"
                        type="text"
                        maxlength="12"
                        placeholder="Codigo PIN"
                        ref="pin"
                    />
                </div>
                <div class="form-group d-flex justify-content-center">
                    <button class="btn btn-primary btn-noradius" @click="PagoMovilPin">
                        Confirmar Suscripción
                        <spinner v-if="isLoadingPagoMovilPinUrl" class-name="color-white"/>
                    </button>
                </div>
                <div
                    class="text-center alert-text-box"
                    :class="{
                        'color-red': !colorMensajePin ,
                        'color-green': colorMensajePin
                    }"
                    v-if="pinMessage != ''"
                >
                    {{ pinMessage }}
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import {
    getCategoriaDeProducto,
    getProducto,
    userTieneProducto,
    getProductoDeCategoria,
    getAllAccessDeProducto
} from "../utilities/data";
import {
    faCheck,
    faSpinner,
    faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";
import SiteFooter from "../components/SiteFooter";
import Spinner from "../components/Spinner";
import TopBar from "../components/TopBar";
import {isValidEmail, isValidTelefono, rutEsValido} from "../utilities/util";
import {mapState, mapGetters} from "vuex";

export default {
    name: "checkoutAlternativeLanding",
    components: {
        bModal,
        SiteFooter,
        Spinner,
        TopBar
    },
    directives: {
        focus: {
            // Definición de directiva
            inserted: function (el) {
                el.focus()
            }
        }
    },
    head: {
        title() {
            return {
                inner: this.curso.producto
            };
        }
    },
    computed: {
        curso() {
            return this.portal.productos_portal
                ? getProducto(this.portal, this.$route.params.id)
                : {};
        },
        isTelefonoValid() {
            return isValidTelefono(this.telefono.toString());
        },
        ...mapState(["portal", "user", "site", "isPortalReady"]),
        ...mapGetters(["userId"]),
        producto() {
            return this.portal.productos_portal.find(
                p => p.id == this.$route.params.id
            );
        },
    },
    watch: {},
    data() {
        return {
            error_term_cond: false,
            confirm_term_cond: true,
            confirm_of_user: false,
            dif_operador: false,
            colorMensajeMovil: false,
            errorMessage: "",
            fecha_entrega_share: null,
            id_descuento: null,
            id_user_share: null,
            isIdSessionEntelModalVisible: false,
            isLoadingPagoMovilUrl: false,
            isLoadingPagoMovilPinUrl: false,
            isLoadingPagoUrl: false,
            isMovilModalVisible: false,
            isPagoLandingMessage: "",
            isPagoUrlLandingModalVisible: false,
            isPinModalVisible: false,
            mainColor: "purple",
            mensaje_entrega_share: null,
            movilMessage: "",
            msisdnEntel: "",
            operador_suscribir: "",
            pin: "",
            pinMessage: "",
            portalPasarelas: [],
            productoSeleccionado: this.$route.params.id,
            service_ip_entel: false,
            selectedPortalPasarela: null,
            telefono: "",
            telefono_suscribir: "",
            validated: false,
            mensajes: {
                "METODO PAGO INVALIDO": "Por favor escoge otro medio de pago.",
                "COMPRA NO ENCONTRADA": "Compra inválida.",
                "EL PRODUCTO YA SE ENCUENTRA DISPONIBLE":
                    "Ya tienes este producto.",
                "PARAMETROS VACIOS":
                    "Por favor coloca todos los datos requeridos.",
                "PARAMETROS REQUERIDOS":
                    "Por favor coloca todos los datos requeridos.",
                "ERROR TOKEN INVALIDO":
                    "Error procesando la compra, por favor intenta de nuevo.",
                ERROR:
                    "Error procesando la compra, por favor intenta de nuevo.",
                "ALTA EXISTE":
                    "Error el numero de telefono se encuentra dado alta con este servicio",
                "OPERADOR INVALIDO":
                    "El numero de telefono no corresponde con el operador seleccionado",
                "TELEFONO VACIO, INVALIDO O FALTAN PARAMETROS":
                    "Error procesando la compra, por favor intenta de nuevo.",
                "El movil no tiene saldo.": "El movil no tiene saldo.",
                "Fallo en configuracion de validacion.":
                    "Fallo en configuracion de validacion.",
                "El movil ya esta agendado.": "El movil ya esta agendado.",
                "El plan no se encuentra registrado":
                    "El plan no se encuentra registrado",
                "IP no autorizada.": "IP no autorizada.",
                "Contenido no valido.": "Contenido no valido.",
                "Entrada no valida.": "Entrada no valida.",
                "Suscripcion Fallida.": "Suscripcion Fallida.",
                "Cobro Fallido.": "Cobro Fallido.",
                "Error Interno.": "Cobro Fallido.",
                "El movil debe pertenecer a EPCS.":
                    "El movil debe pertenecer a EPCS.",
                "El movil no es compatible.": "El movil no es compatible.",
                "El movil esta en roaming.": "El movil esta en roaming.",
                "El movil tiene bloqueado el servicio.":
                    "El movil tiene bloqueado el servicio.",
                "Solicitud no valida.": "Solicitud no valida.",
                "El movil no tiene perfil compatible":
                    "El movil no tiene perfil compatible",
                "El proveedor ha alcanzado el límite Diario y Mensual de suscripciones":
                    "El proveedor ha alcanzado el límite Diario y Mensual de suscripciones",
                "El proveedor ha alcanzado el límite Diario de suscripciones":
                    "El proveedor ha alcanzado el límite Diario de suscripciones",
                "El proveedor ha alcanzado el límite Mensual de suscripciones":
                    "El proveedor ha alcanzado el límite Mensual de suscripciones",
                "El movil no posee tokens": "El movil no posee tokens",
                "La url al servicio segmentate no esta disponible":
                    "La url al servicio segmentate no esta disponible",
                "El pin ingresado es incorrecto":
                    "El pin ingresado es incorrecto",
                "Error al suscribir al movil": "Error al suscribir al movil",
                "CREDITOS INSUFICIENTES": "Error los créditos son insuficientes"
            },
        };
    },
    methods: {
        openConfirmUser() {
            if (this.confirm_term_cond && this.telefono != "") {
                this.confirm_of_user = true
            }
            if (this.confirm_term_cond == false)
                this.error_term_cond = true
        },
        cargar_pasarela(id_product) {
            this.$log.warn('inicio cargar pasarela')
            console.log("inicio cargar pasarela");

            if (
                this.portal.productos_portal.filter(
                    producto => producto.id == id_product
                ).length > 0
            ) {
                // Cargar pasarelas del producto/portal
                this.portalPasarelas = this.portal.productos_portal
                    .filter(producto => producto.id == id_product)[0]
                    .productos_pasarelas.map(pp => {
                        return {
                            id_portal_pasarela: pp.id_portal_pasarela,
                            pasarela:
                                pp.productos_portal_pasarela[0].pasarelas[0]
                        };
                    });

                if (this.portalPasarelas.length > 0 && this.msisdnEntel == "") {
                    //Si el query route posee operador se selecciona una pasarela de operadores
                    if (typeof this.$route.query.operador !== "undefined") {
                        let firstPasarelaMovil = this.portalPasarelas.find(
                            ({pasarela}) => {
                                //Encontrar pasarela movil
                                if (pasarela.is_movil) {
                                    return pasarela;
                                }
                            }
                        );

                        if (typeof firstPasarelaMovil !== "undefined") {
                            this.selectedPortalPasarela = firstPasarelaMovil;
                        } else {
                            this.selectedPortalPasarela = this.portalPasarelas[0];
                        }
                    } else {
                        this.selectedPortalPasarela = this.portalPasarelas[0];
                    }
                }

                //SELECCIONAR MEOTOD PAGO
                dataLayer.push({
                    event: "checkoutOption",
                    ecommerce: {
                        checkout_option: {
                            actionField: {
                                step: 2,
                                option: this.selectedPortalPasarela.pasarela
                                    .pasarela
                            }
                        }
                    }
                });
            } else {
                // El id del curso no existe.
                this.$router.replace({name: "error404"});
            }
        },
        async entelIP() {
            this.$log.warn('inicio entelIP')
            /* LLAMAR HEADER ENTEL */
            this.service_ip_entel = true;
            this.isLoadingPagoUrl = true;

            await this.$api
                .service_ip_entel({content: window.location.href})
                .then(response => {
                    //console.log("IP ENTEL ", response);
                    if (response.data.validated == "true") {
                        localStorage.setItem(
                            "service_ip_entel",
                            response.data.action
                        );

                        if (
                            typeof this.$route.query.operador !== "undefined" &&
                            typeof this.$route.query.entelsid === "undefined" &&
                            typeof this.$route.query.error === "undefined"
                        ) {
                            this.isPagoUrlLandingModalVisible = true;
                            //Redirecciona al smanager de antel que se forma en CMSApi
                            window.location = response.data.action;
                        }
                    } else {
                        localStorage.setItem("service_ip_entel", "");
                        //Se comenta cambio de operador suscribir que interviene en el request de landing preworks
                        //this.operador_suscribir = "";
                    }

                    localStorage.setItem(
                        "selectedPortalPasarela",
                        JSON.stringify(this.selectedPortalPasarela)
                    );

                    this.service_ip_entel = false;
                    this.isLoadingPagoUrl = false;
                });
        },
        entelConfirm() {
            var self = this;

            if (typeof this.$route.query.entelsid !== "undefined") {
                this.isIdSessionEntelModalVisible = true;
                this.msisdnEntel = "Espere por favor";

                /* LLAMAR IDSESSION ENTEL */
                this.$api
                    .service_idsession_entel({
                        idsession: this.$route.query.entelsid
                    })
                    .then(response => {
                        if (
                            response.data.validated == "true" &&
                            localStorage.getItem("selectedPortalPasarela")
                        ) {
                            this.isIdSessionEntelModalVisible = true;
                            this.msisdnEntel = response.data.msisdn;
                            localStorage.setItem("header", "true");
                            localStorage.setItem(
                                "telefono_suscribir",
                                response.data.msisdn
                            );
                            localStorage.setItem("isTelefonoValid", "true");
                            this.operador_suscribir = "entel";

                            self.telefono = response.data.msisdn;
                            this.telefono = response.data.msisdn;

                            this.selectedPortalPasarela = JSON.parse(
                                localStorage.getItem("selectedPortalPasarela")
                            );
                        } else {
                            this.msisdnEntel = "No identificado";
                            this.operador_suscribir = "";
                        }
                    });
            } else if (typeof this.$route.query.error !== "undefined") {
                this.msisdnEntel = "No identificado";
                this.operador_suscribir = "";
                this.isIdSessionEntelModalVisible = true;
            }
        },
        getEmepelloToken() {
            return new Promise((resolve, reject) => {
                Empello.getToken(function (token) {
                    resolve(token);
                });
            });
        },
        landingOperador() {
            let queryOperador = this.operador_suscribir;
            this.portalPasarelas.forEach(pasarelas => {
                if (
                    pasarelas.pasarela.is_movil == 1 &&
                    queryOperador.toLowerCase() != "" &&
                    queryOperador.toLowerCase() ==
                    pasarelas.pasarela.pasarela.toLowerCase()
                ) {
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        queryOperador.toLowerCase()
                    ) {
                        //Si el telefono ha sido identificado
                        if (
                            localStorage.getItem("header") == true &&
                            localStorage.getItem("telefono_suscribir") != ""
                        ) {
                            console.log("Identificado");
                            this.$log.warn('Identificado')
                            return false;
                        } else {
                            this.$log.warn('No identificado')
                            console.log("No identificado");
                            this.setPortalPasarela(pasarelas, event);
                            return false;
                        }
                    }
                    this.setPortalPasarela(pasarelas, event);
                }
            });
        },
        async LandingsPreWorks(pinPreWork) {
            this.$log.warn('inicio landingsPreWorks')
            console.log('landingPreWork....open')
            let empelloToken = "";

            if (
                this.operador_suscribir === "entel" &&
                localStorage.getItem("header") === "true" &&
                typeof pinPreWork === "undefined"
            ) {
                empelloToken = await this.getEmepelloToken();
            } else if (
                this.operador_suscribir === "entel" &&
                localStorage.getItem("header") === "false" &&
                typeof pinPreWork !== "undefined"
            ) {
                empelloToken = await this.getEmepelloToken();
            }

            /* Se evita toda la logica realizada hasta ahora (Registro -- Login y pago) y se encamina al usuario al flujo necesario (Landing Pre-work)*/
            let preworkData = {
                idPasarela: this.selectedPortalPasarela.pasarela.id,
                operador_suscribir: this.operador_suscribir,
                network:
                    Object.getOwnPropertyNames(this.$route.query).length > 0
                        ? this.$route.query
                        : "",
                utm_source: this.$route.query.utm_source ? this.$route.query.utm_source : null,
                utm_medium: this.$route.query.utm_medium ? this.$route.query.utm_medium : null,
                utm_campaign: this.$route.query.utm_campaign ? this.$route.query.utm_campaign : null,
                deviceName:
                    this.selectedPortalPasarela.pasarela.pasarela == "Movistar"
                        ? "Huawei"
                        : "",
                deviceId: 1587, //Este dato es inventado
                idProduct: this.producto.id,
                header: localStorage.getItem("header"),
                msisdn: localStorage.getItem("telefono_suscribir"),
                pin: typeof pinPreWork !== "undefined" ? pinPreWork : "",
                empelloFraudStopToken: empelloToken
            };
            this.$store
                .dispatch("landingPreWork", preworkData)
                .then(response => {
                    this.$log.warn('Antes del dispatch de landingPrework')
                    console.log("Todo bien en el dispatch de landingPrework");
                    //CASO MOVISTAR
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        "movistar"
                    ) {
                        //Solicito Pin
                        if (response.status == 202) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                        } else if (response.status == 201) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.isLoadingPagoMovilPinUrl = false;
                            this.pinMessage = response.message;
                        } else if (response.status == 200) {
                            this.$router.push({
                                name: "CheckoutFinish",
                                params: {
                                    pasarela: "preworklandingoperador",
                                    id_compra: response.data.id,
                                    estado: "aprobado",
                                    productoLanding: response.data.producto
                                }
                            });
                        } else if (response.status == 16) {
                            this.isPagoUrlLandingModalVisible = false;
                            window.location.href = response.url_redirect;
                        } else if (response.status == 1) {
                            this.isPagoUrlLandingModalVisible = true;
                            this.isPagoLandingMessage = response.message;

                            setTimeout(() => {
                                this.isPagoUrlLandingModalVisible = false;
                                this.isPagoLandingMessage = "";
                            }, 3500);
                        }
                    }
                    //CASO ENTEL
                    else if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        "entel"
                    ) {
                        //Solicito Pin
                        if (response.status == 202) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            //this.urlPin = response.data;
                        } else if (response.status == 201) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.isLoadingPagoMovilPinUrl = false;
                            this.pinMessage = response.message;
                            //this.urlPin = response.data;
                        } else if (response.status == 200) {
                            this.$router.push({
                                name: "CheckoutFinish",
                                params: {
                                    pasarela: "preworklandingoperador",
                                    id_compra: response.data.id,
                                    estado: "aprobado",
                                    productoLanding: response.data.producto
                                }
                            });
                        } else if (response.status == 1) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = false;
                            this.isLoadingPagoMovilPinUrl = false;
                            this.isPagoUrlLandingModalVisible = true;
                            this.isPagoLandingMessage = response.message;

                            setTimeout(() => {
                                this.isPagoUrlLandingModalVisible = false;
                                this.isPagoLandingMessage = "";
                            }, 3500);
                        }
                    }
                })
                .catch(error => {
                    if (
                        error.data.status != 1 &&
                        error.data.status != 16 &&
                        error.data.status != 202 &&
                        error.data.status != 201 &&
                        error.data.status != 200
                    ) {
                        //Caso general
                        this.isPagoUrlLandingModalVisible = true;
                        this.isPagoLandingMessage = error.data.message;

                        setTimeout(() => {
                            //Caso Movistar
                            this.isPagoUrlLandingModalVisible = false;
                            this.isPagoLandingMessage = "";

                            //Caso Entel
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = false;
                            this.isLoadingPagoMovilPinUrl = false;
                            this.pinMessage = "";
                        }, 4500);
                    }
                });
        },
        async movistarIP() {
            this.$log.warn('inicio movistarIP')
            console.log('Llegue a movistarIP')
            //Mostrar modal de identificacion de numeros
            this.isIdSessionEntelModalVisible = true;
            this.msisdnEntel = "Espere por favor";

            /*LLAMMAR HEADER MOVISTAR */
            if (typeof this.$route.query.id === "undefined") {
                var thisinterno = this;
                this.isLoadingPagoUrl = true;
                this.service_ip_entel = true;

                let TOKEN = "";
                let DATA = "";

                await this.$api
                    .service_json_movistar_encode({post: null})
                    .then(response => {
                        this.$log.warn('response de json_movistar_encode', response)
                        DATA = response.data;
                        this.$log.warn('DATA:', DATA)
                        this.$api
                            .service_token_movistar({post: null})
                            .then(response2 => {
                                TOKEN = response2.data;
                                console.log(TOKEN)
                                this.$log.warn('TOKEN:', TOKEN)
                                this.$log.warn('response2 de json_movisar_encode:', response2)
                                if (DATA != "" && TOKEN != "") {
                                    var domain =
                                        "https://wstcb-mobile.terra.com/wstcb/Detect.asmx/WhoTime";
                                    var url =
                                        domain +
                                        "?data=" +
                                        DATA +
                                        "&ttkn=" +
                                        TOKEN;

                                    $.ajax({
                                        type: "GET",
                                        url: url,
                                        contentType:
                                            "application/x-www-form-urlencoded",
                                        dataType: "JSONP",
                                        success: function (result) {
                                            this.$log.warn('result de wstcb-mobile.terra.com/wstcb/Detect.asmx/WhoTime:', result)
                                            var msg = "";
                                            var e1 = "";
                                            var e2 = "";
                                            if (
                                                result.RESPONSE[0].MESSAGE !=
                                                undefined
                                            )
                                                msg =
                                                    result.RESPONSE[0].MESSAGE;
                                            if (
                                                result.RESPONSE[0].E1 !=
                                                undefined
                                            )
                                                e1 = result.RESPONSE[0].E1;
                                            if (
                                                result.RESPONSE[0].E2 !=
                                                undefined
                                            )
                                                e2 = result.RESPONSE[0].E2;
                                            thisinterno.$log.warn('antes de service_json_movistar_decode', [e1, e2])
                                            thisinterno.$api.service_json_movistar_decode({data: {e1: e1, e2: e2}})
                                                .then(responseDecodeMovistar => {
                                                        if (responseDecodeMovistar.data.data.length > 0) {
                                                            thisinterno.$log.warn('decode ok', responseDecodeMovistar)
                                                            //Telefono
                                                            localStorage.setItem(
                                                                "telefono_suscribir",
                                                                responseDecodeMovistar.data.data[0]
                                                            );
                                                            thisinterno.telefono = parseInt(
                                                                responseDecodeMovistar
                                                                    .data
                                                                    .data[0],
                                                                10
                                                            );

                                                            //Pin
                                                            thisinterno.pin = parseInt(
                                                                responseDecodeMovistar
                                                                    .data
                                                                    .data[1],
                                                                10
                                                            );

                                                            //Completar 0 del pin
                                                            if (
                                                                thisinterno.pin.toString()
                                                                    .length == 3
                                                            ) {
                                                                thisinterno.pin =
                                                                    "0" +
                                                                    thisinterno.pin;
                                                            }

                                                            //Completar 0 del pin
                                                            if (
                                                                thisinterno.pin.toString()
                                                                    .length == 2
                                                            ) {
                                                                thisinterno.pin =
                                                                    "0" +
                                                                    "0" +
                                                                    thisinterno.pin;
                                                            }

                                                            //Completar 0 del pin
                                                            if (
                                                                thisinterno.pin.toString()
                                                                    .length == 1
                                                            ) {
                                                                thisinterno.pin =
                                                                    "0" +
                                                                    "0" +
                                                                    "0" +
                                                                    thisinterno.pin;
                                                            }

                                                            localStorage.setItem(
                                                                "header",
                                                                true
                                                            );
                                                            localStorage.setItem(
                                                                "isTelefonoValid",
                                                                "true"
                                                            );
                                                            //TODO analizar si el selected portal pasarela es necesario
                                                            localStorage.setItem(
                                                                "selectedPortalPasarela",
                                                                ""
                                                            );

                                                            if (
                                                                typeof thisinterno
                                                                    .$route
                                                                    .query
                                                                    .operador !==
                                                                "undefined"
                                                            ) {
                                                                if (
                                                                    thisinterno.telefono !=
                                                                    "" &&
                                                                    thisinterno.pin !=
                                                                    ""
                                                                ) {
                                                                    thisinterno.movistarConfirm();
                                                                }
                                                            }
                                                        } else {
                                                            console.log("no identificado movistar");
                                                            thisinterno.$log.warn('no identificado movistar')
                                                            //El numero no pudo ser desencriptado
                                                            thisinterno.msisdnEntel =
                                                                "No identificado";
                                                            //thisinterno.isIdSessionEntelModalVisible = false;
                                                            thisinterno.operador_suscribir =
                                                                "";
                                                        }
                                                    }
                                                )
                                                .catch(error => {
                                                    thisinterno.$log.warn('decode error', error)
                                                    console.log("Error", error);
                                                });
                                        },
                                        complete: function (result) {
                                            console.log("ajax completado");
                                            thisinterno.isLoadingPagoUrl = false;
                                            thisinterno.service_ip_entel = false;
                                        },
                                        error: function (e) {
                                            thisinterno.$log.warn('Ajax error', e)
                                            console.log("Ajax error", e);
                                        }
                                    });
                                }
                            });
                    });
            }
        },
        movistarConfirm() {
            this.$log.warn('inicio movistarConfirm')
            console.log('Llegue a movistarConfirm')
        
            if (typeof this.$route.query.operador !== "undefined" &&
                this.telefono != "" &&
                this.pin != ""
            ) {
                //Asignar numero identificado a telefono
                this.msisdnEntel = this.telefono;
                //Mostrar modal de confirmacion
                this.isIdSessionEntelModalVisible = true;
            } else {
                return false;
            }
        },
        operadorPreDetect: function () {
            this.$api
                .operadorPreDetect()
                .then(response => {
                    if (response.data.status == "200") {
                        //Defino operador y llamo a landing operador para seleccionar la pasarela correcta
                        this.operador_suscribir = response.data.operador;
                        if (this.operador_suscribir.toLowerCase() == this.$route.query.operador.toLowerCase() || this.$route.query.operador == 'default')
                            this.landingOperador();
                        else
                            this.dif_operador = true
                    } else {
                        this.operador_suscribir = "";
                        if (this.operador_suscribir.toLowerCase() == this.$route.query.operador.toLowerCase() || this.$route.query.operador == 'default')
                            this.landingOperador();
                        else
                            this.dif_operador = true
                    }
                })
                .catch(error => {
                    this.operador_suscribir = "";
                    if (this.operador_suscribir.toLowerCase() == this.$route.query.operador.toLowerCase() || this.$route.query.operador == 'default')
                        this.landingOperador();
                    else
                        this.dif_operador = true
                });
        },
        pagar() {
            console.log("Estoy Pagando", this.user.id);
            //Si el usuario no esta identificado
            if (this.user.id == 0) {
                //Si es una suscipcion por landing de un operador y el numero fue identificado
                if (
                    typeof this.$route.query.operador !== "undefined" &&
                    localStorage.getItem("telefono_suscribir").length >= 9
                ) {
                    //alert(localStorage.getItem("telefono_suscribir"));
                    console.log(
                        "Estoy enviando el telefono despues de identificar el operador"
                    );
                    this.submitTelefono(
                        localStorage.getItem("telefono_suscribir")
                    );
                }

                //Si es una suscipcion por landing de un operador o el numero no ha sido identificado
                if (
                    typeof this.$route.query.operador === "undefined" ||
                    localStorage.getItem("telefono_suscribir").length <= 9
                ) {
                    //Redirigir a pagina
                    this.$router.push({
                        name: "home"
                    });
                }
            }

            return false;
        },
        PagoMovil() {
            if (this.user.id == 0) {
                //this.$store.commit("togglePortalRegistroModal", true);
                return false;
            }

            this.isLoadingPagoMovilUrl = true;

            // Es pago con postback
            this.$api
                .getPagoUrl({
                    id_producto:
                        this.productoSeleccionado == false
                            ? this.$route.params.id
                            : this.productoSeleccionado,
                    id_portal_pasarela: this.selectedPortalPasarela
                        .id_portal_pasarela,
                    id_moneda: this.selectedPortalPasarela.pasarela.monedas[0]
                        .id,
                    id_descuento: this.id_descuento,
                    id_user_share: this.id_user_share,
                    total: this.producto.precio,
                    fecha_entrega: this.fecha_entrega_share,
                    mensaje_entrega: this.mensaje_entrega_share,
                    network:
                        Object.getOwnPropertyNames(this.$route.query).length > 0
                            ? this.$route.query
                            : "",
                    utm_source: localStorage.getItem("utm_source"),
                    utm_medium: localStorage.getItem("utm_medium"),
                    utm_campaign: localStorage.getItem("utm_campaign"),
                    deviceName:
                        this.selectedPortalPasarela.pasarela.pasarela ==
                        "Movistar"
                            ? "Huawei"
                            : "",
                    deviceId:
                        this.selectedPortalPasarela.pasarela.pasarela ==
                        "Movistar"
                            ? this.user.id
                            : "",
                    idProduct:
                        this.selectedPortalPasarela.pasarela.pasarela ==
                        "Movistar"
                            ? this.producto.movistar_id_producto
                            : "",
                    header:
                        this.selectedPortalPasarela.pasarela.pasarela ==
                        "Movistar" || this.msisdnEntel != ""
                            ? this.header
                            : "",
                    msisdn: this.telefono_suscribir
                })
                .then(response => {
                    //console.log("RESPUESTA PAGO MOVIL", response);
                    this.isLoadingPagoMovilUrl = false;
                    this.isLoadingPagoUrl = false;

                    if ("message" in response.data) {
                        if (response.data.message in this.mensajes) {
                            this.movilMessage = this.mensajes[
                                response.data.message
                                ];
                            if (
                                !this.isMovilModalVisible &&
                                this.movilMessage != ""
                            ) {
                                this.isMovilModalVisible = true;
                            }
                            return false;
                        }
                        this.colorMensajeMovil = false;
                        if (
                            !this.isMovilModalVisible &&
                            this.movilMessage != ""
                        ) {
                            this.isMovilModalVisible = true;
                        }
                        return false;
                    }

                    if (
                        typeof response.data.response.response !==
                        "undefined" &&
                        response.data.response.response == "400"
                    ) {
                        this.movilMessage = response.data.response.message;

                        if (response.data.response.message in this.mensajes) {
                            this.movilMessage = this.mensajes[
                                response.data.response.message
                                ];
                            if (
                                !this.isMovilModalVisible &&
                                this.movilMessage != ""
                            ) {
                                this.isMovilModalVisible = true;
                            }
                            return false;
                        }
                        this.colorMensajeMovil = false;
                        if (
                            !this.isMovilModalVisible &&
                            this.movilMessage != ""
                        ) {
                            this.isMovilModalVisible = true;
                        }
                        return false;
                    }

                    dataLayer.push({
                        event: "boton-pagar"
                    });

                    this.id_compra = response.data.id_compra;

                    //localStorage.removeItem("utm_source");
                    //localStorage.removeItem("utm_medium");
                    localStorage.removeItem("telefono_suscribir");
                    localStorage.removeItem("header");

                    //CASO MOVISTAR
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        "movistar"
                    ) {
                        if (response.data.response.includes("aprobado")) {
                            //CHECKOUT
                            dataLayer.push({
                                event: "checkout",
                                ecommerce: {
                                    checkout: {
                                        actionField: {step: 3, option: ""},
                                        products: [
                                            {
                                                name: this.producto.producto,
                                                id: this.producto.id,
                                                price: this.producto.precio,
                                                category: this.categoria
                                                    .categoria,
                                                quantity: 1
                                            }
                                        ]
                                    }
                                }
                            });

                            window.location = response.data.response;
                        } else if (response.data.response.includes("store")) {
                            //CHECKOUT
                            dataLayer.push({
                                event: "checkout",
                                ecommerce: {
                                    checkout: {
                                        actionField: {step: 3, option: ""},
                                        products: [
                                            {
                                                name: this.producto.producto,
                                                id: this.producto.id,
                                                price: this.producto.precio,
                                                category: this.categoria
                                                    .categoria,
                                                quantity: 1
                                            }
                                        ]
                                    }
                                }
                            });

                            window.location = response.data.response;
                        } else {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.urlPin = response.data.response;
                        }
                    }

                    //CASO ENTEL
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        "entel"
                    ) {
                        if (response.data.response.includes("aprobado")) {
                            //CHECKOUT
                            dataLayer.push({
                                event: "checkout",
                                ecommerce: {
                                    checkout: {
                                        actionField: {step: 3, option: ""},
                                        products: [
                                            {
                                                name: this.producto.producto,
                                                id: this.producto.id,
                                                price: this.producto.precio,
                                                category: this.categoria
                                                    .categoria,
                                                quantity: 1
                                            }
                                        ]
                                    }
                                }
                            });

                            window.location = response.data.response;
                        } else if (
                            response.data.response.includes("movil_entel")
                        ) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.urlPin = response.data.response;
                        }
                    }

                    //CASO WOM
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        "wom"
                    ) {
                        if (response.data.response.includes("aprobado")) {
                            //CHECKOUT
                            dataLayer.push({
                                event: "checkout",
                                ecommerce: {
                                    checkout: {
                                        actionField: {step: 3, option: ""},
                                        products: [
                                            {
                                                name: this.producto.producto,
                                                id: this.producto.id,
                                                price: this.producto.precio,
                                                category: this.categoria
                                                    .categoria,
                                                quantity: 1
                                            }
                                        ]
                                    }
                                }
                            });

                            window.location = response.data.response;
                        } else if (
                            response.data.response.includes("movil_wom")
                        ) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.urlPin = response.data.response;
                        }
                    }
                });
        },
        PagoMovilPin() {
            this.isLoadingPagoMovilPinUrl = true;

            //console.log("QUERY operador", this.$route.query.operador);
            //Si es operador entel y esta en un landing se hace flujo de landings preworks
            if (
                (this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                    "entel" ||
                    this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                    "movistar") &&
                typeof this.$route.query.operador !== "undefined"
            ) {
                /* Se evita toda la logica realizada hasta ahora (Registro -- Login y pago) y se encamina al usuario al flujo necesario (Landing Pre-work)*/
                this.LandingsPreWorks(this.pin);
            } else {
                this.$api
                    .pago_url_pin({
                        pin: this.pin,
                        msisdn: this.telefono_suscribir,
                        idProduct:
                            this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                            "movistar"
                                ? 1789
                                : 241,
                        deviceId: this.user.id,
                        alta: "false",
                        urlPin: this.urlPin
                    })
                    .then(response => {
                        this.isLoadingPagoMovilPinUrl = false;

                        if (
                            typeof response.data.response !== "undefined" &&
                            response.data.response == "400"
                        ) {
                            this.pinMessage = response.data.message;
                            if (response.data.message in this.mensajes) {
                                this.pinMessage = this.mensajes[
                                    response.data.message
                                    ];
                                return false;
                            }
                            this.colorMensajePin = false;
                            return false;
                        }
                        window.location = response.data.url_redirect;
                    });
            }
        },
        setPortalPasarela(portalPasarela, event) {
            if (portalPasarela.pasarela.visible) {
                this.selectedPortalPasarela = portalPasarela;

                //SELECCIONAR MEOTOD PAGO
                dataLayer.push({
                    event: "checkoutOption",
                    ecommerce: {
                        checkout_option: {
                            actionField: {
                                step: 2,
                                option: portalPasarela.pasarela.pasarela
                            }
                        }
                    }
                });

                //intentar la identificacion solo si el usuario no introdujo el numero
                if (this.telefono !== "") {
                    return false;
                }

                switch (portalPasarela.pasarela.pasarela) {
                    case "Entel":
                        this.entelIP();
                        break;

                    case "Wom":
                        this.womIP();
                        break;

                    case "Movistar":
                        this.movistarIP();
                        break;

                    case "Cencosud":
                        //this.isCencosudModalVisible = true;
                        break;

                    case "BancoEstado":
                        this.bancoEstadoSelected();
                        break;
                }
            } else {
                event.preventDefault();
                return false;
            }
        },
        start() {
            this.$log.warn('inicio Start')
            console.log("inicio Start");
            this.cargar_pasarela(
                this.productoSeleccionado == false
                    ? this.$route.params.id
                    : this.productoSeleccionado
            );
            this.isVisible = true;
        },
        async submitTelefono(telf) {
            this.$log.warn('inicio submit telefono')
            console.log("inicio Submit telefono", telf);
            this.validated = true;
            let isValid = true;

            if (!this.isTelefonoValid && localStorage.getItem("header") == "false") {
                isValid = false;
            }

            if (!isValid) {
                return false;
            }

            //TODO ver si aun se usa
            //Si existe la variable sat en la url y se esta visitando el sitio desde un navegadir movil
            if (typeof this.$route.query.sat !== "undefined") {
                var ua = navigator.userAgent.toLowerCase();

                if (ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1) {
                    window.open(
                        "sms://+7676&body=" + this.producto.alias_movistar,
                        "_system"
                    );
                } else {
                    window.open(
                        "sms://+7676?&body=" + this.producto.alias_movistar,
                        "_system"
                    );
                }

                return false;
            }

            //Si el telefono identificado es distinto de vacio y el telefono del imput no fue suministrado
            if (this.msisdnEntel != "" && this.telefono != "") {
                //El telefono a suscribir es el identificado por la red
                telf = this.msisdnEntel;
            } else {
                //El telefono a suscribir es el indicado en el imput
                telf = this.telefono;
            }

            let newUserData = {
                usuario: "",
                activarCuentaCheckout: 1,
                name: "",
                apellido: "",
                email: "",
                telefono: telf,
                direccion: "",
                termino_condicion: 1,
                password: "",
                sexo: "",
                fecha_nac: "",
                registro_telefono: 1,
                utm_source: localStorage.getItem("utm_source"),
                utm_medium: localStorage.getItem("utm_medium"),
                utm_campaign: localStorage.getItem("utm_campaign")
            };

            if (isValid) {
                var operador_movil = "";
                await this.$api.operador({telefono: telf}).then(response => {
                    operador_movil = response.data
                        .replace("<response>", "")
                        .replace("</response>", "");
                    this.operador_suscribir = operador_movil.toLowerCase();
                    if (operador_movil == "Entel") {
                        fbq("track", "InitiateCheckout");
                    }
                });

                this.isPagoUrlLandingModalVisible = true;

                if (
                    this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                    "movistar" ||
                    this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                    "entel"
                ) {
                    //Escribo numero de telefono en local storage
                    localStorage.setItem("telefono_suscribir", telf);
                    //si el pin fue pre- identificado se envia a con el landing prework
                    if (this.pin != "") {
                        this.LandingsPreWorks(this.pin);
                    } else {
                        this.LandingsPreWorks();
                    }
                } else {
                    //La pasarela seleccionada no permite suscripciones por landings de operadores
                    return false;
                }
            }
        },
    },
    mounted() {
        this.$log.warn('mounted')
        //Inicializar pagina y reaccionar a url de entel o wom
        if (this.portal.productos_portal) {
            this.$log.warn('this.portal.productos_portal')
            this.start();
            this.entelConfirm()
        }

        //Identificar operador del visitante
        if (typeof this.$route.query.operador !== "undefined") {
            this.operadorPreDetect();
        }

    },
    created() {
        //Si hay un usuario registrado obtener numero
        if (
            typeof this.user.telefono !== "undefined" &&
            this.user.telefono != ""
        ) {
            this.telefono = this.user.telefono;
        }

        localStorage.setItem(
            "telefono_suscribir",
            typeof this.user.telefono !== "undefined" &&
            this.user.telefono != ""
                ? this.user.telefono
                : ""
        );

        localStorage.setItem("header", false);

        //Agregando EMPELLO FRAUDSTOOP
        let empelloFraudStop = document.createElement("script");
        empelloFraudStop.setAttribute(
            "src",
            "https://antifraud.empello.net/arfnjblk/taamqkke-live.js"
        );
        document.head.appendChild(empelloFraudStop);
    },
};
</script>

<style>
.alternative_checkout {
    background-color: whitesmoke;
}

.bar {
    margin-bottom: 10px;
}

.content {
    min-height: 90vh;
}

input[type="checkbox"]:focus {
    background-color: black;
    color: red;
}
</style>
